import { TooltipTrigger_default as e } from "../../../../node_modules/.pnpm/reka-ui@2.5.1_patch_hash_1a_da296058102805d3e82696b7a23dd27c/node_modules/reka-ui/dist/Tooltip/TooltipTrigger.js";
import { createBlock as t, defineComponent as n, mergeProps as r, openBlock as i, renderSlot as a, unref as o, withCtx as s } from "vue";
//#region src/components/ui/tooltip/core/TooltipTrigger.vue?vue&type=script&setup=true&lang.ts
var c = /* @__PURE__ */ n({
	__name: "TooltipTrigger",
	props: {
		reference: {},
		asChild: { type: Boolean },
		as: { type: [
			String,
			Object,
			Function
		] }
	},
	setup(n) {
		let c = n;
		return (n, l) => (i(), t(o(e), r({ "data-slot": "tooltip-trigger" }, c, { "as-child": "" }), {
			default: s(() => [a(n.$slots, "default")]),
			_: 3
		}, 16));
	}
});
//#endregion
export { c as default };

//# sourceMappingURL=TooltipTrigger_vue.js.map